/** Formats an ISO date string or Date as a two-digit day/month/year using the browser's locale. */
export function formatDate(date: Date | string) {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

/**
 * Formats a Date as `YYYY-MM-DD` using local date components (not `toISOString`,
 * which converts to UTC and can shift the calendar day for negative-UTC-offset
 * users near midnight).
 */
export function toApiDateString(date: Date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
